import React from 'react';

import { defineMessages, type MessageDescriptor, useIntl } from 'react-intl-next';

import { IconButton } from '@atlaskit/button/new';
import ChevronLeftIcon from '@atlaskit/icon/core/chevron-left';
import { Box } from '@atlaskit/primitives/compiled';

import { useAudioPlayerStore } from '../../../hooks/useAudioPlayerStore';
import { ModalHeader } from '../ModalHeader';


const i18n = defineMessages({
	backButtonLabel: {
		id: 'ai-audio.audio-player.overflow-menu.back-button-label',
		defaultMessage: 'Back',
		description: 'The label for the back button in the overflow menu panel',
	},
	backButtonAriaLabel: {
		id: 'ai-audio.audio-player.overflow-menu.back-button-aria-label',
		defaultMessage: 'Back to audio player',
		description: 'The aria label for the back button in the overflow menu panel',
	},
});


export type PanelWrapperProps = {
	children: React.ReactNode;
	header: MessageDescriptor;
	onBack: () => void;
};

export const PanelWrapper = ({
	header,
	onBack,
	children,
}: PanelWrapperProps): React.JSX.Element => {
	const { closeAudioPlayer } = useAudioPlayerStore();
	const { formatMessage } = useIntl();

	const BackButton = () => (
		<IconButton
			icon={ChevronLeftIcon}
			appearance="subtle"
			label={formatMessage(i18n.backButtonAriaLabel)}
			spacing="compact"
			onClick={onBack}
			testId="overflow-menu-panel-back-button"
		/>
	);

	return (
		<>
			<ModalHeader
				leftElement={<BackButton />}
				heading={header}
				onClose={closeAudioPlayer}
			/>
			<Box>{children}</Box>
		</>
	);
};
